import React from 'react';
import { Container, Heading, Text } from '@chakra-ui/react';

const SearchAnalytics: React.FC = () => {
  return (
    <Container maxW="container.xl" py={6}>
      <Heading size="lg" color="white" mb={4}>
        Search Analytics
      </Heading>
      <Text color="gray.400">
        Search analytics dashboard coming soon...
      </Text>
    </Container>
  );
};

export default SearchAnalytics;